module.exports = __webpack_public_path__ + "img/steuntje.5669a8f3.png";